/**
 * Freeze background scroll without touching overflow/padding.
 *
 * Setting body { overflow: hidden } removes (or restyles) the scrollbar and
 * changes layout width; even with scrollbar-gutter and padding hacks, some
 * browsers still shift content left. Instead we pin window.scroll and ignore
 * background wheel/touch while allowing scroll inside [data-scroll-lock-scrollable].
 *
 * Nested locks are ref-counted (Follow modal + mobile menu).
 */

let freezeX = 0;
let freezeY = 0;
let wheelTouchHandler = null;
let scrollHandler = null;

function isScrollableTarget(target) {
  if (!target || typeof target.closest !== "function") return false;
  return Boolean(target.closest("[data-scroll-lock-scrollable]"));
}

function onWheelOrTouch(e) {
  if (isScrollableTarget(e.target)) {
    /* Allow native scroll inside the modal/sheet */
    return;
  }
  e.preventDefault();
}

function onWindowScroll() {
  if (window.scrollX !== freezeX || window.scrollY !== freezeY) {
    window.scrollTo(freezeX, freezeY);
  }
}

function attachFreeze() {
  freezeX = window.scrollX || window.pageXOffset || 0;
  freezeY = window.scrollY || window.pageYOffset || 0;

  wheelTouchHandler = onWheelOrTouch;
  scrollHandler = onWindowScroll;

  window.addEventListener("wheel", wheelTouchHandler, {
    passive: false,
    capture: true,
  });
  window.addEventListener("touchmove", wheelTouchHandler, {
    passive: false,
    capture: true,
  });
  window.addEventListener("scroll", scrollHandler, { passive: true });
}

function detachFreeze() {
  if (wheelTouchHandler) {
    window.removeEventListener("wheel", wheelTouchHandler, {
      capture: true,
    });
    window.removeEventListener("touchmove", wheelTouchHandler, {
      capture: true,
    });
    wheelTouchHandler = null;
  }
  if (scrollHandler) {
    window.removeEventListener("scroll", scrollHandler);
    scrollHandler = null;
  }
}

export function lockBodyScroll() {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  const count = Number(root.dataset.scrollLocks || 0);
  root.dataset.scrollLocks = String(count + 1);
  if (count > 0) return;

  attachFreeze();
}

export function unlockBodyScroll() {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  const count = Number(root.dataset.scrollLocks || 0) - 1;
  if (count > 0) {
    root.dataset.scrollLocks = String(count);
    return;
  }
  delete root.dataset.scrollLocks;
  detachFreeze();
}
